import { EarlyBirdOfferItemDto } from "app/shared/model/EarlyBirdOfferDto";

export enum ActionType {
    PageLoaded = "EarlyBirdOfferList/PageLoaded",
    Other = "__OTHER__",
}

export type PageLoadedEvent = {
    type: ActionType.PageLoaded;
    offers: EarlyBirdOfferItemDto[];
    divisionId: number;
};

export type OtherAction = {
    type: ActionType.Other;
};

export type Action = PageLoadedEvent | OtherAction;